import map from 'lodash/map';

import endpointsResource, { Throttling } from 'src/actions/endpoints/endpointsResource';
import { DomainError } from 'src/models/DomainError';
import * as sharedTypes from 'src/actions/shared/sharedTypes';
import validateType from 'src/adapters/validateType';

interface Err {
  attr: string;
  code: string;
  detail: string;
  toJs: Function;
}

// This custom translation ensures that the errors
// display on the correct fields in the editor UI
function translateThrottlingErrors(errors: Err[]): DomainError[] {
  return map(errors, err => {
    if (err.attr) {
      return {
        attr: `configuration.throttling.${err.attr}`,
        code: err.code,
        detail: err.detail,
      };
    }

    return err.toJs();
  });
}

// validateThrottling will validate only the `Throttling`
// object within the chat configuration
export const validateThrottling: sharedTypes.AppThunk = (attrs: any) => dispatch => {
  try {
    validateType(Throttling, attrs);
  } catch (err) {
    dispatch(endpointsResource.actions.validationError(translateThrottlingErrors((err as any).errors)));
    return false;
  }
  return true;
};
